"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Update2 = _interopRequireDefault(require("@mui/icons-material/Update"));
var _GridLegacy2 = _interopRequireDefault(require("@mui/material/GridLegacy"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _colors = require("@mui/material/colors");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cancellablePromise = require("../hooks/cancellable-promise");
var _services = require("../services");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BikeStationAvailabilities({
  bikeStation: {
    id,
    availableClassicBikes,
    availableEBikes,
    availableLots
  },
  enqueueSnackbar,
  onUpdated,
  setBikeStation,
  setHistory
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _cancellablePromise.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    update();
    return () => cancelPromises();
  }, []);
  async function update() {
    cancelPromises();
    setHistory(undefined);
    try {
      const _bikeStation = await cancellablePromise(_services.BikeStationService.getBikeStation(id, {
        history: true
      }));
      setHistory(_bikeStation.history?.reverse());
      setBikeStation(_bikeStation);
      return _bikeStation;
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
        enqueueSnackbar?.(t('commons.bike_stations.refresh_error'));
      }
      throw err;
    }
  }
  async function refresh() {
    try {
      const _bikeStation = await update();
      onUpdated?.(_bikeStation);
    } catch (err) {
      console.error(err);
    }
  }
  return /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    item: true,
    display: "flex",
    flexDirection: "column",
    xs: 3
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.bike_stations.bikes"
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: availableClassicBikes < 5 ? _colors.red[500] : 'inherit',
    variant: "h6"
  }, availableClassicBikes)), /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    item: true,
    display: "flex",
    flexDirection: "column",
    xs: 5
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.bike_stations.e-bikes"
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: availableEBikes < 5 ? _colors.red[500] : 'inherit',
    variant: "h6"
  }, availableEBikes)), /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    item: true,
    display: "flex",
    flexDirection: "column",
    xs: 3
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.bike_stations.slots"
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: availableLots < 5 ? _colors.red[500] : 'inherit',
    variant: "h6"
  }, availableLots)), /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    item: true,
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    xs: 1
  }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.bike_stations.actions.refresh_availabilities"
    })
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: refresh,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Update2.default, null))))));
}
var _default = exports.default = BikeStationAvailabilities;